<template>
  <div class="myRequest">
    <div class="rent-content" ref="pdfContent" v-if="!showDelete">
      <div v-if="!editEvent">
        <div class="rent-title-box">
          <span class="rent-title">My Requests</span>
          <el-button class="cart-info viewRequest" @click="addNewRequest()" plain>Add New Request</el-button>
        </div>
        <div class="searchBox">
          <el-input
            clearable
            placeholder="Search"
            suffix-icon="el-icon-search"
            class="searchInput"
            v-model="requestSearch"
            @change="getMyRequestList"
          >
          </el-input>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <el-select
            clearable
            v-model="requestSelect"
            placeholder="Select"
            @change="getMyRequestList"
          >
            <el-option
              v-for="(item) in statusArr"
              :key="item.id"
              :label="item.status"
              :value="item.status"
            ></el-option>
          </el-select>
          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
          <span class="timeZone">Time Zone: <span>{{ timeZone }}</span></span>
          <el-button
            type="primary"
            style="float: right" size="small"
            @click="download"
            v-loading="excelLoading"
            :disabled="tableData.length == 0"
          >
            <i class="iconfont icon-download1"></i>
            Excel
          </el-button>
          <el-table
            :data="tableData"
            style="width: 100%"
            border
            v-loading="tableLoading"
            class="requestTable"
          >
            <el-table-column
              type="index"
              label="#"
              :index="indexMethod"
            >
            </el-table-column>
            <el-table-column
              prop="hubspotTicketId"
              label="Ticket ID"
            >
            </el-table-column>
            <el-table-column
              prop="Project/Event Name"
              label="Project/Event Name"
              width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.requestData.redBullEventName }}
              </template>
            </el-table-column>
            <el-table-column
              label="Rental Items"
            >
              <template slot-scope="scope">
                <p
                  v-for="item in scope.row.requestData.lineItemList"
                  :key="item.id"
                >
                  {{ item.quantity }} {{ item.productName }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="Ticket Status"
              label="Ticket Status"
              min-width="120"
            >
              <template slot-scope="scope">
                <span :style="{ color : statusInfo[scope.row.ticketStatus] }">{{ scope.row.ticketStatus }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="Submitted Date"
              label="Submitted Date"
            >
              <template slot-scope="scope">
                <p>
                  {{ showFormatTime(scope.row.createTime) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="Operation"
              label="Operation"
            >
              <template slot-scope="scope">
                <i
                  class="iconfont icon-Edit"
                  v-if="scope.row.ticketStatus === 'Ticket Generated'"
                  @click="operater(0, scope.row.requestData, scope.row.hubspotTicketId)"
                >
                </i>
                <i
                  v-if="scope.row.ticketStatus === 'Closed Success'"
                  class="iconfont icon-Show"
                  @click="operater(1, scope.row.requestData)"
                >
                </i>
                <i
                  class="iconfont icon-Copy"
                  @click="operater(2, scope.row.requestData)"
                >
                </i>
                <i
                  v-if="scope.row.ticketStatus === 'Ticket Generated'"
                  class="iconfont icon-Delete"
                  @click="operater(3, scope.row, scope.row.hubspotTicketId)"
                >
                </i>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            class="pagination"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <div v-else>
        <div class="rent-title-box">
          <span class="rent-title">Let’s Rent!</span>
          <el-button class="cart-info viewRequest" @click="go2OldRequestList" plain>View My Requests
          </el-button>
        </div>
        <br>
        <ConfirmAddress
          :editEventInfo="editEventInfo"
          :locationList="locationList"
          :hubspotTicketId="hubspotTicketId"
          :detailId="detailId"
          @updateTable="updateTable"
          v-if="moreShow === 'edit'"
        >
        </ConfirmAddress>

        <ReviewConfirmSave v-if="moreShow === 'view'"></ReviewConfirmSave>
      </div>
    </div>
    <AfterDelete
      v-else
      :showConfirm="showDelete"
      @showRequest="go2OldRequestList"
      @addNewRequest="addNewRequest"
    ></AfterDelete>
  </div>
</template>

<script>
import ConfirmAddress from './MyRequest/ConfirmAddressSave'
import ReviewConfirmSave from './MyRequest/ReviewConfirmSave'
import AfterDelete from './MyRequest/AfterDelete'
import moment from 'moment/moment'
// import ConfirmPage from '@/views/SimpleRental/ConfirmPage.vue'

export default {
  name: 'MyRequest',
  components: {
    ConfirmAddress,
    ReviewConfirmSave,
    AfterDelete
  },
  props: {
    locationList: {
      type: Array,
      default: () => []
    },
    detailId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showPage: false,
      firstPage: true,
      showMyRequest: false,
      requestSearch: '',
      requestSelect: '',
      statusArr: [
        {
          id: 'TICKET GENERATED',
          label: 'TICKET GENERATED'
        }, {
          id: 'PREPARATION COMPLETE',
          label: 'PREPARATION COMPLETE'
        }, {
          id: 'OUTBOND SHIPPING',
          label: 'OUTBOND SHIPPING'
        }, {
          id: 'RENTAL PERIODE',
          label: 'RENTAL PERIODE'
        }, {
          id: 'OVERDUE',
          label: 'OVERDUE'
        }, {
          id: 'INBOUND SHIPPING',
          label: 'INBOUND SHIPPING'
        }, {
          id: 'EQUIPMENT RECEIVING',
          label: 'EQUIPMENT RECEIVING'
        }, {
          id: 'EQUIPMENT QC',
          label: 'EQUIPMENT QC'
        }, {
          id: 'CLOSED SUCCESS',
          label: 'CLOSED SUCCESS'
        }, {
          id: 'CLOSED CANCELLED',
          label: 'CLOSED CANCELLED'
        }
      ],
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableLoading: false,
      statusInfo: {
        'Ticket Generated': '#E26601',
        'Preparation Complete': 'green',
        'Outbound Shipping': 'green',
        'Rental Period': 'green',
        'Inbound Shipping': 'gray',
        Overdue: 'red',
        'Equipment Receiving': 'gray',
        'Equipment QC': 'gray',
        'Pending Follow Up': '#E26601',
        'Closed Success': 'gray',
        'Closed Failed': 'red',
        'Closed Cancelled': 'gray',
        'Eval Signed': 'gray',
        'Rental Request Confirmed': 'green'
      },
      editEvent: false,
      editEventInfo: false,
      hubspotTicketId: '',
      excelLoading: false,
      moreShow: '',
      detailInfo: null,
      showDelete: false
    }
  },
  computed: {
    timeZone () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  mounted () {
    if (this.detailId) {
      // 如果有id说明是从邮件里面打开的
      this.getDetailInfo(this.detailId)
      return
    }
    this.getStatusList()
    this.getMyRequestList()
    // Bus.$on('cartNumChange', () => {
    //   this.cartNumChange()
    // })
  },
  methods: {
    indexMethod (index) {
      const startIndex = (this.currentPage - 1) * this.pageSize
      return startIndex + index + 1
    },
    showFormatTime (stamp) {
      return moment(stamp).format('YYYY-MM-DD HH:mm:ss')
    },
    getTimezoneOffset () {
      function z (n) {
        return (n < 10 ? '0' : '') + n
      }
      let offset = new Date().getTimezoneOffset()
      const sign = offset < 0 ? '+' : '-'
      offset = Math.abs(offset)
      return sign + z(offset / 60 | 0) + ':' + z(offset % 60)
    },
    getStatusList () {
      this.$axios.post('/rental-forecasting/ticketStatus').then(res => {
        if (res.data.errorCode === '0x0') {
          this.statusArr = res.data.result
        } else {
          this.$message.error(res.data.errorInfo)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    updateTable (isEmail) {
      if (isEmail) {
        // 说明是从email进来的
        this.$emit('showConfirmPage', this.detailInfo)
        return
      }
      this.editEvent = false
      this.getMyRequestList()
    },
    getMyRequestList () {
      const zoon = this.getTimezoneOffset()
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ticketId: this.requestSearch,
        ticketStatus: this.requestSelect,
        timeZone: zoon
      }
      this.tableLoading = true
      this.$axios.post('/rental-forecasting/redBull/request', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const { list, total, pageNum } = res.data.result
          this.tableData = list
          this.total = total
          this.currentPage = pageNum
        } else {
          this.$message.error(res.data.errorInfo)
        }
        this.tableLoading = false
      }).catch((error) => {
        this.tableLoading = false
        this.$message.error(error)
      })
    },
    addNewRequest (isNotClear) {
      this.$emit('addNewRequest', isNotClear)
    },
    viewOldRequest () {
      this.getMyRequestList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getMyRequestList()
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.getMyRequestList()
    },
    download () {
      const url = '/rental-forecasting/redBull/request?export=true'
      const zoon = this.getTimezoneOffset()
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ticketId: this.requestSearch,
        ticketStatus: this.requestSelect,
        timeZone: zoon
      }
      this.excelLoading = true
      this.$axios.post(url, params, { responseType: 'blob' }).then(async res => {
        const filename = res.headers['content-disposition'].split('=')[1]
        const url = window.URL.createObjectURL(new Blob([res.data])) // 在内存中生成一个 URL 实例
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        this.excelLoading = false
      }).catch((error) => {
        this.excelLoading = false
        this.$message.error(error)
      })
    },
    setData2Localstorage (row) {
      const params = {}
      let end = new Date()
      let start = new Date()
      end = moment(start.getTime() + 3600 * 1000 * 24 * 7).format('YYYY-MM-DD')
      start = moment(start).format('YYYY-MM-DD')
      params.startDate = start
      params.endDate = end
      params.redBullEventName = row.redBullEventName
      params.internalNumber = row.internalNumber
      // 第一步的数据存储
      localStorage.setItem('eventInfo', JSON.stringify(params))

      const chooseProducts = row.lineItemList
      const specialRentalProductRequest = row.specialRentalProductRequest
      // 第二步的数据存储
      localStorage.setItem('chooseProducts', JSON.stringify(chooseProducts))
      localStorage.setItem('specialRentalProductRequest', specialRentalProductRequest)

      const {
        businessContactFirstName,
        businessContactLastName,
        businessContactCompany,
        businessContactEmail,
        businessContactPhone,
        businessContactCommunicationType,
        businessOtherCommunicationMethods,
        businessContactCountry,
        businessContactState,
        shippingContactFirstName,
        shippingContactLastName,
        shippingContactCompany,
        shippingContactEmail,
        shippingContactPhone,
        shippingOtherCommunicationMethods,
        shippingContactCommunicationType,
        shippingAddress1,
        shippingAddress2,
        buildingName,
        shippingCountry,
        shippingState,
        shippingCity,
        shippingZipCode,
        saveDetails,
        sendRentalRequestConfirmationMailToShippingContact,
        shippingInfo
      } = row
      const formRental = {
        // Business Contacts Information
        businessContactFirstName: businessContactFirstName,
        businessContactLastName: businessContactLastName,
        businessContactCompany: businessContactCompany,
        businessContactEmail: businessContactEmail,
        businessContactPhone: businessContactPhone,
        businessContactCommunicationType: businessContactCommunicationType,
        businessOtherCommunicationMethods: businessOtherCommunicationMethods,
        businessContactCountry: businessContactCountry,
        businessContactState: businessContactState,
        // Shipping Contacts information
        shippingContactFirstName: shippingContactFirstName,
        shippingContactLastName: shippingContactLastName,
        shippingContactCompany: shippingContactCompany,
        shippingContactEmail: shippingContactEmail,
        shippingContactPhone: shippingContactPhone,
        shippingOtherCommunicationMethods: shippingOtherCommunicationMethods,
        shippingContactCommunicationType: shippingContactCommunicationType,
        // Shipping Address
        shippingAddress1: shippingAddress1,
        shippingAddress2: shippingAddress2,
        buildingName: buildingName,
        shippingCountry: shippingCountry,
        shippingState: shippingState,
        shippingCity: shippingCity,
        shippingZipCode: shippingZipCode,
        // internalNumber: ''
        saveDetails: saveDetails,
        sendRentalRequestConfirmationMailToShippingContact: sendRentalRequestConfirmationMailToShippingContact,
        shippingInfo: shippingInfo
      }
      // 第三步的数据存储
      localStorage.setItem('confirmAddress', JSON.stringify(formRental))
      const {
        operatorFirstName,
        operatorLastName,
        operatorCompanyName,
        operatorEmailAddress,
        operatorGreenToolkitLink,
        operatorIFB,
        operatorNote,
        sendRentalRequestConfirmationMailToOperator
      } = row
      const additionalInfo = {
        operatorFirstName: operatorFirstName,
        operatorLastName: operatorLastName,
        operatorCompanyName: operatorCompanyName,
        operatorEmailAddress: operatorEmailAddress,
        operatorGreenToolkitLink: operatorGreenToolkitLink,
        operatorIFB: operatorIFB,
        operatorNote: operatorNote,
        sendRentalRequestConfirmationMailToOperator: sendRentalRequestConfirmationMailToOperator
      }
      // 第四步的数据存储
      localStorage.setItem('additionalInfo', JSON.stringify(additionalInfo))
    },
    getDetailInfo (id) {
      const params = {
        id: id
      }
      this.$axios.post('/rental-forecasting/listBullTicketInfoById', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const data = res.data.result[0]
          this.detailInfo = data.request_data
          this.detailInfo.ticketId = data.hubspot_ticket_id
          this.operater(0, data.request_data, data.hubspot_ticket_id)
        } else {
          this.$message.error(res.data.errorInfo)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    operater (type, row, hubspotTicketId) {
      // type => 0: 编辑 1: 查看 2: 复制 3: 删除
      if (type === 0) {
        this.editEvent = true
        this.editEventInfo = row
        this.moreShow = 'edit'
        this.hubspotTicketId = hubspotTicketId
      } else if (type === 1) {
        this.setData2Localstorage(row)
        this.editEvent = true
        this.moreShow = 'view'
      } else if (type === 2) {
        this.setData2Localstorage(row)
        this.addNewRequest(true)
      } else if (type === 3) {
        // delete
        this.$confirm('', 'Are you sure you want to cancel this request?', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'review-confirm-box',
          type: 'warning'
        }).then(() => {
          const params = {
            hubspotTicketId: hubspotTicketId
          }
          this.tableLoading = true
          this.$axios.post('/rental-forecasting/deleteRedBullTicket', params).then(res => {
            if (res.data.errorCode === '0x0') {
              this.getMyRequestList()
              this.editEvent = false
              this.moreShow = ''
              this.showDelete = true
              // this.$message.success('Delete success')
            } else {
              this.$message.error(res.data.errorInfo)
            }
            this.tableLoading = false
          }).catch((error) => {
            this.tableLoading = false
            this.$message.error(error)
          })
        }).catch(() => {
        })
      }
    },
    go2OldRequestList () {
      this.editEvent = false
      this.moreShow = ''
      this.$emit('showRequest')
    }
  }
}
</script>

<style scoped lang="less">
.myRequest {
  width: 100%;
  height: auto;
  padding: 50px 0;
  position: relative;
  bottom: 50px;

  .title-box {
    width: 500px;
    color: #000;
    position: absolute;
    left: 388px;
    top: 260px;
    .title {
      font-size: 48px;
      line-height: 56px;
    }

    .sec-title {
      margin-top: 20px;
      width: 410px;
      font-size: 14px;
    }
  }

  /deep/ .rent-content {
    width: 1200px;
    z-index: 999;
    position: absolute;
    background: #FFFFFF;
    border-radius: 6px;
    box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.20);
    padding: 24px 36px;
    top: 80px;
    left: 50%;
    margin-left: -600px;

    .searchBox {
      width: 100%;
      margin-top: 26px;
      overflow: hidden;

      .searchInput {
        width: 272px;
      }

      .timeZone {
        font-weight: 400;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 150%;
        letter-spacing: 0px;
        color: #595959;

        span {
          font-family: Roboto;
          font-weight: 400;
          font-size: 14px;
          leading-trim: NONE;
          line-height: 150%;
          letter-spacing: 0px;
          color: #141414;
        }
      }

      .el-input__prefix, .el-input__suffix {
        color: gray;
        line-height: 32px;
      }

      .requestTable {
        background: #fff;
        border-top: 2px solid #F8F8F8 !important;
        border-left: 2px solid #F8F8F8 !important;
        border-right: 2px solid #F8F8F8 !important;

        &::before {
          background-color: #EBEEF5 !important;
        }

        .has-gutter {
          background: #DBDBDB;
        }

        th {
          background: #fff !important;
          border-bottom: 1px solid #F8F8F8 !important;
          border-right: 1px solid #F8F8F8 !important;
        }

        tr {
          background: #fff !important;
          border-bottom: 1px solid #DBDBDB;

          td {
            border-bottom: 1px solid #F8F8F8;
            color: #434343;
            border-right: 1px solid #F8F8F8 !important;
          }
        }

        .iconfont {
          font-size: 22px;
          padding: 0 6px;
          color: #CCCCCC;
          cursor: pointer;

          &:hover {
            color: #69AD48 !important;
          }
        }
      }

      .el-pagination {
        float: right;
        margin-top: 16px;

        .btn-prev, .btn-next, .btn-quicknext, .btn-quickprev {
          background: #fff;
          color: #999999;
        }

        .number {
          background: #fff;
          color: #999999;
        }
      }
    }
  }

  .rent-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .rent-title {
      color: #69AD48;
      font-size: 24px;
      font-weight: 500;
    }

    .cart-info {
      display: flex;
      align-items: center;
      position: relative;

      .cart-num {
        background-color: #69AD48;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        line-height: 18px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        position: absolute;
        left: 2px;
        top: -9px;
      }

      .icon-gouwuche {
        font-size: 24px;
        color: #666666;
      }

      span {
        color: #666666;
        font-size: 14px;
        font-weight: 700;
        margin-left: 8px;
      }
    }
  }

  .step-box {
    width: 1128px;
    border-radius: 4px;
    border: 1px solid #DBDBDB;
    background: #FAFAFA;
    padding: 12px 0;
    margin-top: 24px;
    margin-bottom: 36px;
  }

  .flex-center {
    display: flex;
  }

  /deep/ .el-button--success, /deep/ .el-button--primary {
    background-color: #69AD48 !important;
    border-color: #69AD48 !important;
    padding: 12px 25px !important;
  }

  /deep/ .el-input {
    .el-input__inner {
      background-color: #FFFFFF;
      border: 1px solid #DBDBDB;
      color: #333333;
      padding-left: 8px;
    }

    .el-input__inner::placeholder {
      color: #CCCCCC;
    }
  }

  /deep/ .el-select .el-input .el-select__caret {
    color: #252525;
  }

  /deep/ .el-form-item__label {
    color: #000000;
    line-height: 16px;
    margin-bottom: 6px;
  }

  /deep/ .el-range-editor {
    background-color: #FFFFFF;
    border: 1px solid #DBDBDB;
  }

  /deep/ .el-checkbox__inner {
    background: #FAFAFA !important;
    border-color: #C6C6C6;
  }

  /deep/ .el-button.is-disabled {
    background: #8BC194 !important;
    border-color: #8BC194 !important;
  }

  /deep/ .is-checked .el-checkbox__inner {
    background-color: #69AD48 !important;
    border-color: #69AD48 !important;
  }

  /deep/ .el-step {
    cursor: pointer;
  }

  .viewRequest {
    background: #fff;
    color: #33ab4f;
  }

  .firstPage {
    width: 680px;
    height: 680px;
    background: #fff;
    text-align: center;
    vertical-align: middle;
    position: absolute;
    right: 20px;
    top: 120px;

    .title {
      font-weight: 500;
      font-size: 32px;
      leading-trim: NONE;
      line-height: 100%;
      letter-spacing: 0px;
      text-align: center;
      color: #000;
      margin-top: 200px;
    }

    .viewRequest {
      background: #fff;
      color: #33ab4f;
      margin-bottom: 26px;
      width: 320px;
      margin-top: 126px;
      height: 64px;
    }

    .addRequest {
      width: 320px;
      height: 64px;
    }
  }
}
</style>
